<script>
    const socialLinkTemplates = {
        'ok': 'https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=__url__',
        'fb':'http://www.facebook.com/sharer.php?u=__url__',
        'vk':'http://vk.com/share.php?url=__url__&title=__title__&comment=__description__',
        'twitter':'https://twitter.com/intent/tweet?url=__url__&text=__description__&hashtags=__hashtags__',
    }

    export default {
        data: function(){
            return {
                selected: false,
                edit: null,
                items: this.data.items || [],
                highlightedIcon: null,
                baseUrl: '/',
                lastSize: null,
            }
        },
        mounted: function() {
            this.baseUrl = this.$root.baseUrl;
        },
        methods: {
            addItem: function() {
                if (this.$parent.selected) {
                    this.items.push({});
                    this.edit = this.items.length-1;
                }
            },
            editItem: function(index) {
                if (this.$parent.selected) {
                    this.edit = index;
                }
            },
            deleteItem: function(index) {
                this.items.splice(index, 1);
                this.focus();
            },
            updateStyles: function(data) {
                this.update(this.data.id, {'style': data});
                this.$forceUpdate();
            },
            updateData: function(data) {
                this.lastSize = data.size;
                this.items[data.index] = data;
                this.edit = null;
                this.$emit('update', this.data.id, {items: this.items});
            },
            closeDialog: function() {
                //remove empty item if add cancelled
                if (!this.items[this.edit]['type']) {
                    this.items.splice(this.edit, 1);
                }
                this.edit = null;
            },
            getShareLink: function(item) {
                if (item && item.type) {
                    let url = socialLinkTemplates[item.type].replace(
                        '__url__', item.url ? item.url : '{@ webversion_url|encode_url @}'
                    ).replace(
                        '__title__', item.title ? item.title : '{@ subject|encode_url @}'
                    ).replace(
                        '__description__', item.description ? item.description : ''
                    ).replace(
                        '__hashtags__', item.hashtags.length ? item.hashtags.join(',').replace(/#/g, '') : ''
                    )
                    return url;
                } else {
                    return '';
                }
            },
            dragEnd: function() {
                this.$emit('update', this.data.id, {items: this.items});
                console.log(JSON.stringify(this.items));
            }
        }
    }
</script>
